import { useState } from 'react';

const CustomInput = ({
  label,
  unit,
  type, name,
  value, onChange, placeholder,
  error,
  help
}) => {
  const [isFocused, setIsFocused] = useState(false);

  return (
    <div style={{ }}>
      <label style={{
          color: '#333', marginBottom: '8px', display: 'block', fontWeight: 600
        }}
      >{label}</label>
      <div style={{ 
        display: 'flex',
        position: 'relative',
        boxShadow: isFocused ? '0 0 0 0.2rem rgba(247, 146, 34, 0.25)' : 'none',
        borderRadius: '4px',
        transition: 'box-shadow 0.15s ease-in-out'
      }}>
        {unit && (
          <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            backgroundColor: 'white', 
            border: '1px solid #ced4da',
            borderRight: 'none', 
            borderTopLeftRadius: '4px', 
            borderBottomLeftRadius: '4px', 
            padding: '0 12px',
            borderColor: isFocused ? '#F79222' : '#ced4da',
            position: 'relative'
        }}>
          <span style={{
            fontSize: '18px',
            fontWeight: '600',
            color: '#adb5bd',
            letterSpacing: '0.5px'
          }}>{unit}</span>
          <span style={{
            position: 'absolute',
            right: 0,
            top: '12px',
            bottom: '12px',
            width: '1px',
            backgroundColor: '#e9ecef'
            }}></span>
          </div>
        )}
        <input
          type={type}
          style={{ 
            flex: 1, 
            height: '45px', 
            padding: '10px 12px', 
            fontSize: '16px', 
            border: '1px solid #ced4da', 
            borderLeft: unit ? 'none' : '1px solid #ced4da',
            borderRight: help ? 'none' : '1px solid #ced4da',
            outline: 'none',
            borderColor: isFocused ? '#F79222' : '#ced4da',
            borderRadius: '4px',
            borderTopLeftRadius: unit ? '0px' : '4px',
            borderBottomLeftRadius: unit ? '0px' : '4px',
            borderTopRightRadius: help ? '0px' : '4px',
            borderBottomRightRadius: help ? '0px' : '4px'
          }}
          name={name}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
        />
        {help && (
          <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            backgroundColor: 'white', 
            border: '1px solid #ced4da', 
            borderLeft: 'none', 
            borderTopRightRadius: '4px', 
            borderBottomRightRadius: '4px', 
            padding: '0 12px',
            borderColor: isFocused ? '#F79222' : '#ced4da'
        }}>
            <i className="fa fa-question-circle" style={{ color: '#6c757d' }}></i>
          </div>
        )}
      </div>
      {error && (
        <small style={{ color: '#F9394C', marginTop: '5px', display: 'block' }}>
          {error}
        </small>
      )}
    </div>
  );
};

export default CustomInput;